// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DGEmK","title":"styles_title__OXTPW"};